import { useState, useEffect } from 'react';
// material-ui
import { useTheme } from "@mui/material/styles";
import { Divider, Grid, Stack, Typography, useMediaQuery, Button, Box } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { useTranslation } from 'react-i18next';
import mapwalalogo from "../../../assets/images/logo.png";
// project imports
import AuthWrapper1 from "./AuthWrapper1";
import AuthCardWrapper from "./AuthCardWrapper";
import { MuiOtpInput } from "mui-one-time-password-input";
import { verifyOtp, resendOtp, setError } from "../../../actions/loginActions";
import { createAxiosInstance } from '../../../services/axiosInstance';
import MinimalFooter from '../../../ui-component/cards/MinimalFooter';
import AlertBox from "../../../ui-component/AlertBox";
const LoginOtp = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [otp, setOtp] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const theme = useTheme();
  const matchDownSM = useMediaQuery(theme.breakpoints.down("md"));
  const isAuthenticated = useSelector((state) => state.login.user.isAuthenticated) || sessionStorage.getItem('isAuthenticated');
  const userEmail = useSelector((state) => state.login.user.email);
  const otpToken = useSelector((state) => state.login.user.otpToken);
  const token = useSelector((state) => state.login.user.token);
  const loading = useSelector((state) => state.login.loading);
  const error = useSelector((state) => state.login.error);
  const [remainingTime, setRemainingTime] = useState(180);
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = ''; // This line is necessary for some browsers to show the warning message
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      if (remainingTime > 0) {
        setRemainingTime(remainingTime - 1);
      } else {
        clearInterval(timer);
      }
    }, 1000);

    return () => clearInterval(timer); // Cleanup function to stop timer on unmount
  }, [remainingTime]);
  const handleClick = () => {
    if (remainingTime === 0) {
      dispatch(resendOtp(userEmail, otpToken));
      setRemainingTime(180); // Reset timer after resend
    }
  };
  if (isAuthenticated) {
    createAxiosInstance(sessionStorage.getItem('oAuthToken'));
    return <Navigate to="/dashboard" replace />;
  }
  if (otpToken === null) {
    window.location.href = "/";
  }
  const handleChange = (newValue) => {
    setOtp(newValue);
  };
  const handleOTPSubmit = async () => {
    dispatch(verifyOtp(otpToken, otp, userEmail));
  };
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#eef2f6",
        backgroundImage:
          "url('https://www.transparenttextures.com/patterns/topography.png')",
      }}
    >

      {/* ERROR ALERT */}
      <AlertBox
        severity="error"
        isOpen={error.message !== null}
        handleAlertClick={() => console.log('information of otp verification')}
        title={t("common.error")}
        message={error.message}
      />
      {/* LOADING */}
      {loading && (
        <CircularProgress
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        />
      )}

      <Box sx={{ position: "relative", width: 360 }}>
        {/* Glow */}
        <Box
          sx={{
            position: "absolute",
            inset: -20,
            borderRadius: "20px",
            background: "rgba(0, 150, 255, 0.25)",
            filter: "blur(25px)",
            zIndex: 0,
          }}
        />

        {/* Card */}
        <Box
          sx={{
            position: "relative",
            zIndex: 1,
            p: 4,
            borderRadius: "16px",
            background: "#fff",
            textAlign: "center",
            boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
          }}
        >
          {/* Logo */}
          <Box display="flex" justifyContent="center" alignItems="center" mb={2} sx={{
            p: 1,
            borderRadius: "10px",
            background: "#1E293B",
            display: "inline-block",
          }}>
            <img src={mapwalalogo} style={{ width: 150 }} />

          </Box>
          {/* Text */}
          <Typography fontSize={14} color="#555" mb={3}>
            {t("auth.enterOtpSentToMobile")}
          </Typography>

          {/* <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Grid item xs={12}>
                      <Grid
                        container
                        direction={matchDownSM ? "column-reverse" : "row"}
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Grid item>
                          <Stack
                            alignItems="center"
                            justifyContent="center"
                            spacing={1}
                          > */}
          {/* <Typography
                              color={theme.palette.secondary.main}
                              gutterBottom
                              variant={matchDownSM ? "h3" : "h2"}
                            >
                              MAPWALA
                            </Typography> */}
          {/* <Typography
                              variant="caption"
                              fontSize="16px"
                              textAlign={matchDownSM ? "center" : "inherit"}
                            >
                              {t("auth.enterOtpSentToMobile")}
                            </Typography> */}


          {/* OTP INPUT */}
          <MuiOtpInput
            value={otp}
            onChange={handleChange}
            length={6}
            sx={{
              gap: "10px",   // 🔥 control spacing here
              justifyContent: "center",
            }}

            TextFieldsProps={{
              sx: {
                width: "45px",
                height: "45px",
              },

            }}
          />


          {/* VERIFY BUTTON */}
          <Button
            fullWidth
            onClick={handleOTPSubmit}
            disabled={!otp || otp.length < 6 || loading}
            sx={{
              mt: 3,
              py: 1.2,
              borderRadius: "8px",
              color: "#fff",
              fontWeight: "bold",
              textTransform: "none",
              background: "linear-gradient(90deg,#1976d2,#26c6da)",
            }}
          >
            {loading ? "Verifying..." : "Verify OTP"}
          </Button>

          {/* RESEND */}
          <Box
            mt={2}
            display="flex"
            justifyContent="center"
            alignItems="center"
            gap={1}
          >
            <Typography fontSize={13} color="#666">
              Resend OTP in [{remainingTime}] seconds.
            </Typography>

            <Button
              size="small"
              disabled={remainingTime > 0}
              onClick={handleClick}
              sx={{
                background: "#e0f7fa",
                color: "#00796b",
                textTransform: "none",
                borderRadius: "6px",
                px: 2,
              }}
            >
              Resend
            </Button>
          </Box>

          {/* </Stack>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12}>
                      <MuiOtpInput
                        value={otp}
                        onChange={handleChange}
                        length={6}
                      />
                      <br />
                      <Typography align="center">
                        <Button
                          color="primary"
                          size="large"
                          type="submit"
                          variant="contained"
                          onClick={handleOTPSubmit}
                          disabled={remainingTime <= 0}
                        >
                          {t("auth.verifyOtp")}
                        </Button>
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Divider />
                      <br />
                      <Typography className="otp-timer" style={{ textAlign: "center" }}>
                        <span>{t("auth.resendOtpIn", { seconds: remainingTime })}</span>
                        <Button
                          color="success"
                          size="small"
                          variant="contained"
                          disabled={remainingTime > 0}
                          onClick={handleClick}
                        >
                          {t("auth.resend")}
                        </Button>
                      </Typography>
                    </Grid>
                  </Grid> */}


        </Box>

      </Box>
    </Box>
  );
};

export default LoginOtp;
